"use client";

import { ROUTE_HOME } from "@/constants/routes.constants";
import { useMediaQuery } from "@/hooks/mediaQuery";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { Conversation } from "@/types";
import type React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

type SidebarChatButtonProps = {
  chat: Conversation;
  isCurrPage: boolean;
  hideSidebar: () => void;
};

const SidebarChatButton: React.FC<SidebarChatButtonProps> = ({
  chat,
  isCurrPage,
  hideSidebar,
}) => {
  const nav = useNavigate();
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { setSelectedAgentModel, agentsModels } = useContext(AppContext);
  const isNotSmall = useMediaQuery("sm");

  // Check if text is overflowing
  const checkOverflow = () => {
    if (textRef.current) {
      const isTextOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth;
      setIsOverflowing(isTextOverflowing);
    }
  };

  // Initial check
  useEffect(() => {
    checkOverflow();
  }, [chat.name]);

  function openChat(agentModelId: number) {
    if (!agentsModels) return;
    const selectedAgentModel = agentsModels.find(
      (agentModel) => agentModel.id === agentModelId
    );
    if (!selectedAgentModel) {
      console.error("Agent model not found");
      return;
    }
    setSelectedAgentModel(selectedAgentModel);
    nav(`${ROUTE_HOME}/${chat.id}`);
    if (!isNotSmall) {
      hideSidebar();
    }
  }

  return (
    <Button
      key={chat.id}
      variant={undefined}
      className={`flex w-full items-center justify-start gap-2 overflow-hidden bg-transparent text-left text-white transition-all hover:bg-transparent hover:text-shadow-2xs hover:text-shadow-[#ffffff8a] ${
        isCurrPage ? "bg-gray-700 hover:bg-gray-700" : ""
      }`}
      onClick={() => {
        openChat(chat.agentID);
      }}
      onMouseEnter={checkOverflow}
    >
      <div className="relative w-full">
        <div
          ref={textRef}
          className={`truncate select-none ${isOverflowing ? "hover:animate-slide-horizontal hover:w-max" : ""}`}
        >
          {chat.name}
        </div>
      </div>
    </Button>
  );
};

export default SidebarChatButton;
